/** Partner dashboard: amounts stored in USD (same as admin). */

export function formatUSD(n) {
  return `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}

export function buildReferralLink(referralCode) {
  const base =
    (typeof window !== "undefined" && window.MNF_API_ORIGIN) ||
    (typeof window !== "undefined" ? window.location.origin : "");
  if (!referralCode) return `${base}/personal-registration`;
  return `${base}/personal-registration?ref=${referralCode}`;
}
